<template>
  <div class="main-products-list">
    <div
      v-for="(card, idxCard) in cardsList"
      :key="idxCard"
      v-scroll-to="{
        el: '#main-product-detail',
        lazy: false,
        offset: -64,
      }"
      class="main-products-list__card"
      @click="$emit('selected-section', card.id)"
    >
      <div class="main-products-list__card_img-wrapper">
        <picture>
          <source
            :srcset="
              require(`~/assets/img/main/main--products/${card.img}-1200.webp`)
            "
            media="(min-width: 991px) and (max-width: 1200px)"
          />
          <source
            :srcset="
              require(`~/assets/img/main/main--products/${card.img}-1200.png`)
            "
            media="(min-width: 991px) and (max-width: 1200px)"
          />
          <source
            :srcset="
              require(`~/assets/img/main/main--products/${card.img}.webp`)
            "
          />
          <img
            :src="require(`~/assets/img/main/main--products/${card.img}.png`)"
            width="273"
            height="176"
            loading="lazy"
            alt=""
          />
        </picture>
      </div>

      <div class="main-products-list__card_title">
        {{ card.title }}
      </div>
      <div class="main-products-list__card_list">
        <a
          v-for="(item, idxItem) in card.productsList"
          :key="idxItem"
          :href="item.href"
          class="main-products-list__card_list-item"
          @click.stop=""
          >{{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import MainProductsListMixin from '~/components/Desktop/Main/mixins/MainProductsListMixin'
export default {
  name: 'MainProductsListBlockDesktop',
  mixins: [MainProductsListMixin],
}
</script>
<style lang="scss" scoped>
.main-products-list {
  display: flex;
  column-gap: 8px;
  padding: 32px 0;
  @include screen-down('lg') {
    flex-direction: column;
  }
  &__card {
    $card: &;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding: 24px;
    border-radius: 32px;
    background: #e7e1d8;
    overflow: hidden;
    cursor: pointer;
    &:first-child {
      @include screen-down('lg') {
        margin-bottom: 8px;
      }
    }
    @include screen-up('lg') {
      transition: all 0.275s ease;

      &:hover {
        transform: translateY(-8px);
        #{$card}_img-wrapper {
          transform: translateY(4px);
        }
      }
    }

    &_title {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      max-width: 271px;
    }
    &_list {
      margin-top: 32px;
      display: flex;
      column-gap: 8px;
      @include screen-down('lg') {
        margin-top: 24px;
      }
      &-item {
        display: inline-block;
        padding: 12px 16px;
        background: #ffffff73;
        border-bottom: 1px solid #ffffff4d;
        border-radius: 16px;
        backdrop-filter: blur(8px);
        font-size: 14px;
        line-height: 20px;
        text-decoration: none;
        color: inherit;
        transition: all 0.275s ease;

        &:hover {
          background: #ffffffbf;
          transition: all 0.275s ease;
        }
      }
    }
    &_img-wrapper {
      position: absolute;
      right: 0;
      bottom: 0;
      @include screen-up('lg') {
        transition: all 0.275s ease;
        transform: translateY(14px);
      }
      @include screen-between('lg', 'xl') {
        max-width: 160px;
      }
      @include screen-down('lg') {
        max-width: 223px;
      }
    }
  }
}
</style>
